// Tracks whether the user's last interaction was keyboard-driven (Tab) or
// pointer-driven (mouse/touch), exposed as a class on <html>.
//
// Native `:focus-visible` can't do this for text-like inputs: per spec, browsers
// always treat focus on text/date/tel inputs as "visible" even when it came from
// a mouse click, so there's no CSS-only way to tell the two apart there. This
// class lets components distinguish "clicked into" (border) from "tabbed into"
// (ring) per the design system's active/focused split.
const KEYBOARD_MODALITY_CLASS = "user-is-tabbing";

let initialized = false;

export const initKeyboardModalityTracking = () => {
  if (initialized || typeof window === "undefined") {
    return;
  }
  initialized = true;

  window.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      document.documentElement.classList.add(KEYBOARD_MODALITY_CLASS);
    }
  });

  window.addEventListener("mousedown", () => {
    document.documentElement.classList.remove(KEYBOARD_MODALITY_CLASS);
  });

  window.addEventListener("pointerdown", () => {
    document.documentElement.classList.remove(KEYBOARD_MODALITY_CLASS);
  });
};
